import Icon from "@/components/elements/Icon";

import { useEmitations } from "@/base/hooks/useEmitations";
import * as styles from "./styles.module.scss";

export function EmitationBox() {
  const { co2 } = useEmitations();

  return (
    <div className={styles.emitationBox}>
      {co2 ? (
        <>
          <Icon name="fan" width={57.5} height={52.5} />
          <div>
            <p>
              <b>
                <span>This web page emits only</span>
              </b>
            </p>
            <p>
              <span className={styles.large}>{co2}g</span>
              <span> per visit.</span>
            </p>
            <p>
              <span>
                For 10,000 monthly visits, this web page will emit{" "}
                {((co2 * 10000 * 12) / 1000).toFixed(2)}kg of CO2 per year.
              </span>
            </p>
          </div>
        </>
      ) : (
        <p className={styles.error}>Problem with Co2 API</p>
      )}
    </div>
  );
}
